// extracted by mini-css-extract-plugin
module.exports = {"backToTop":"BackToTop-module--backToTop--3LDNt","hideMobile":"BackToTop-module--hideMobile--1BkXM"};